import { PaginationProps } from "base/components/Pagination";
import { ManuscriptDataAttr } from "types/manuscripts/list";

export const MANUSCRIPT_URL = "manuscript";

export const GET_MANUSCRIPT_LIST_URL = "post/list";
export const GET_MANUSCRIPT_DETAIL_URL = "post/view";
export const GET_MANUSCRIPT_ACTIVITY_URL = "activity/list";
export const RESET_MANUSCRIPT_URL = "post/reset";
export const APPROVE_MANUSCRIPT_URL = "post/approve";
export const REJECT_MANUSCRIPT_URL = "post/reject";
export const DELETE_MANUSCRIPT = "post/delete";
export const SEND_MAIL_URL = "post/email";
export const DOWNLOAD_FILE_URL = "attachment/download";
export const SAVE_COMMENT_URL = "comment/insert";
export const EDIT_COMMENT_URL = "comment/update";
export const DELETE_COMMENT_URL = "comment/delete";
export const GET_MANUSCRIPT_SEND_MAIL_LIST_URL = "email/smtp/sentlist";
export const GET_EMAIL_COMPLETE_LIST_URL = "email/complete/list";
export const SET_CATEGORY_URL = "post/setCategory";
export const GET_DEFAULT_SIGNATURE_URL = "email/writeform/default";
export const GET_SELECT_SIGNATURE_URL = "email/writeform/select";
export const GET_SIGNATURE_INFO_URL = "email/signature/info";
export const GET_VIEW_HISTORY_URL = "post/viewHistory";

export const DEFAULT_PAGINATION: PaginationProps = {
  pageIndex: 1,
  pageTotal: 0,
  pageSize: 10,
  pageCount: 0,
};

export const DEFAULT_DATA_ATTR: ManuscriptDataAttr = {
  categories: [],
  mail_status: [],
  status: [],
};

export const CATEGORY_TYPE_MAP: any = {
  book: 1,
  novel: 2,
  all: undefined,
};